import React from "react";
import "./DefaultEvent.css";
import Row from "react-bootstrap/Row";


function DefaultEvent({event}) {
    return <Row>
        <span>{JSON.stringify(event.payload)}</span>
    </Row>;
}

export default DefaultEvent;
